/* Copyright (c) 2020-present CloudIO Inc */

import { getIn, setIn } from '@cloudio-saas/mutx';
import { Path, useStateXSnapshotCallback } from '@cloudio-saas/statex';

export interface Update {
  value: unknown;
  oldValue: unknown;
  path: Path;
}
export interface Removal {
  oldValue: unknown;
  path: Path;
}

export default function useStateChanges(
  rootPath: Path,
  callback: (updates: Update[], removals: Removal[]) => void,
) {
  useStateXSnapshotCallback(
    ({ state, oldState, updatedPaths, removedPaths }) => {
      if (!(oldState && state)) {
        // ignore root state addition and removal
        // otherwise it causes issues in useIOActive
        return;
      }
      const fState = setIn({}, rootPath, state);
      const fOldState = setIn({}, rootPath, oldState);
      const updates: Update[] = updatedPaths.map((path: Path) => {
        const value = getIn(fState, path, undefined);
        const oldValue = getIn(fOldState, path, undefined);
        return {
          value,
          oldValue,
          path,
        };
      });
      const removals: Removal[] = removedPaths.map((path: Path) => {
        const oldValue = getIn(fOldState, path, undefined);
        return {
          oldValue,
          path,
        };
      });
      callback(updates, removals);
    },
    rootPath,
  );
}
